module.exports = __webpack_public_path__ + "img/demo3.a28ed7e3.png";